var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"app"}},[_c('transition',{attrs:{"name":"fade"}},[_c('loading',{directives:[{name:"show",rawName:"v-show",value:(_vm.showLoading),expression:"showLoading"}]})],1),_c(_vm.layout,{tag:"component"},[_c('router-view')],1),_c('modal-gardenhotels')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }